import { IMember } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorIsDomesticMember = (member: IMember) =>
  member.profile.address?.country
    ? member.profile.address.country === "US"
    : true;
